<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="main">
          <div (click)="closeModal()" class="close-icon">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
          <div class="text-center">
            <img id="success-icon" src="assets/image/success-icon.svg" />
          </div>
          <div class="mt-3 text-center">
            <h3>Cadastro realizado!</h3>
            <p class="mt-3 mb-5">
              Verifique seu e-mail e faça login para começar a enviar e receber dinheiro
              de maneira 100% digital
            </p>
          </div>
          <div>
            <button class="btn btn-block mt-3" type="button" (click)="goToLogin()">
              Fazer login
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>